<template>
    <div>
        <TitleAndExplanation v-if="title || explanation" :title="title" :explanation="explanation"/>
        <div class="form-options">
            <div 
                v-for="item in options" 
                    :key="item.code" 
                    :class="['radio-button_container', { selected: selectedOpt === item.code}]" 
                    @click="emitSelectedOption(item)">
                <span>{{ item.name }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import TitleAndExplanation from '../common/TitleAndExplanation.vue'

export default {
    name: 'InputRadioButtons',
    data() {
        return {
            selectedOpt: null
        }
    },
    components: {
        TitleAndExplanation
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        title: {
            type: String
        },
        explanation: {
            type: String,
            default: ''
        },
        selected: {
            default: ''
        }
    },
    mounted() {
        this.selectedOpt = this.selected;
    },
    watch: {
        selected(newVal) {
            this.selectedOpt = newVal;
        }
    },
    methods: {
        emitSelectedOption(item) {
            this.selectedOpt = item.code;
            this.$emit('valueChanged', item.code);
        }
    }
}
</script>

<style>
    .form-options{
        font-weight: var(--font-weight-medium);
        font-size: var(--font-size-inputs);
        margin-top: 24px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;   
        justify-content: space-between; 
        row-gap:24px;
    }
    .radio-button_container{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        cursor: pointer;
        border-radius: var(--border-radius);
        border: 2px solid var( --gray-light);
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
        /* width: 268px; */
        min-width: 164px;
        box-sizing: border-box;
        padding: 16px;
        line-height: 22px;;
    }
    .radio-button_container.selected {
        border-color: var( --primary);
    }

    /* MOVIL */
    @media (max-width: 768px) {
        .form-options {
            flex-direction: column;
        }
        .radio-button_container{
            width: 100%;
        }
    }
    /* TABLET */
    @media (min-width: 769px) and (max-width: 992px) {
        .form-options {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
            row-gap: 24px;
        }
        .radio-button_container {
            width: 100%;
        }
    }
    /* ESCRITORIO*/
    @media (min-width: 993px) {
        .radio-button_container{
            width: 49%;
        }
    }
</style>